import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInvoiceCollectionBillomatClientMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type UpdateInvoiceCollectionBillomatClientMutation = { __typename?: 'Mutation', updateInvoiceCollectionBillomatClient: boolean };


export const UpdateInvoiceCollectionBillomatClientDocument = gql`
    mutation UpdateInvoiceCollectionBillomatClient($id: ID!) {
  updateInvoiceCollectionBillomatClient(id: $id)
}
    `;
export type UpdateInvoiceCollectionBillomatClientMutationFn = Apollo.MutationFunction<UpdateInvoiceCollectionBillomatClientMutation, UpdateInvoiceCollectionBillomatClientMutationVariables>;

/**
 * __useUpdateInvoiceCollectionBillomatClientMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceCollectionBillomatClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceCollectionBillomatClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceCollectionBillomatClientMutation, { data, loading, error }] = useUpdateInvoiceCollectionBillomatClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInvoiceCollectionBillomatClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceCollectionBillomatClientMutation, UpdateInvoiceCollectionBillomatClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceCollectionBillomatClientMutation, UpdateInvoiceCollectionBillomatClientMutationVariables>(UpdateInvoiceCollectionBillomatClientDocument, options);
      }
export type UpdateInvoiceCollectionBillomatClientMutationHookResult = ReturnType<typeof useUpdateInvoiceCollectionBillomatClientMutation>;
export type UpdateInvoiceCollectionBillomatClientMutationResult = Apollo.MutationResult<UpdateInvoiceCollectionBillomatClientMutation>;
export type UpdateInvoiceCollectionBillomatClientMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceCollectionBillomatClientMutation, UpdateInvoiceCollectionBillomatClientMutationVariables>;